"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeRateApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class FeeRateApi extends runtime.BaseAPI {
    /**
     * Fetch fee rate information.
     * fetch fee rate
     */
    async fetchFeeRateRaw(requestParameters, initOverrides) {
        if (requestParameters.feeRateRequest === null || requestParameters.feeRateRequest === undefined) {
            throw new runtime.RequiredError('feeRateRequest', 'Required parameter requestParameters.feeRateRequest was null or undefined when calling fetchFeeRate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/extended/v1/fee_rate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.FeeRateRequestToJSON(requestParameters.feeRateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.FeeRateFromJSON(jsonValue));
    }
    /**
     * Fetch fee rate information.
     * fetch fee rate
     */
    async fetchFeeRate(requestParameters, initOverrides) {
        const response = await this.fetchFeeRateRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.FeeRateApi = FeeRateApi;
//# sourceMappingURL=FeeRateApi.js.map